<template>
    <div
        class="px-4 py-4 flex items-center space-x-3 bg-white border border-1 hover:bg-gray-100  cursor-pointer focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500 rounded-md transition-all duration-300">
        <div class="flex-shrink-0 mr-4">
            <img :alt="vcard?.name"
                 class="h-8 w-8 rounded-full p-3 bg-gray-300 "
                 src="@src/assets/vectors/user_icon.svg"
            >
        </div>
        <div class="flex-1 min-w-0">
            <div class="focus:outline-none">
                <p class="text-sm font-medium text-gray-900">
                    {{ vcard?.name }}
                </p>
                <p class="text-sm text-gray-500 truncate">
                    {{ vcard?.phone_number }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {useVCards} from "@src/composables/useVcards";

const props = defineProps(['id'])
const vCardComposable = useVCards()
const vcard = vCardComposable.getVcardContactById(parseInt(props.id))
</script>

<style scoped>

</style>
